<template>
  <div class="login">
    <!-- 欢迎登录 -->
    <div class="welcome font64 c333">
      <div>员工认证</div>
      <div class="decoration"></div>
    </div>
    <!-- 欢迎登录end -->

    <!-- 输入账户名密码 -->
    <div class="user">
      <div class="username">
        <input type="number" class="userinput" v-model="code" maxlength="8" placeholder="请输入你的初始化认证码">
      </div>
      <!-- <div class="username mt10">
          <input :type="passwordview? 'text':'password' " class="userinput" placeholder="请输入密码">
          <img :src="passwordview? '/static/image/password-on.png':'/static/image/password.png' " alt="" class="viewpassword" @click="replacePasswordview">
        </div> -->
    </div>
    <!-- 输入账户名密码end -->

    <!-- 登录按钮 -->
    <div class="successbtn btncolor loginbtn" @click="certification()">认证</div>

  </div>
</template>

<script>
import { Notify } from 'vant'
export default {
  name: 'login',
  data () {
    return {
      // passwordview:true
      code: ''
    }
  },
  mounted () {
  },
  methods: {
    // 员工认证
    certification () {
      var that = this
      var data = {
        initCode: that.code
      }
      if (this.isLicensePlate(that.code)) {
        this.$api.HZrequest('/we-chat/gzh/bind-washer', 'POST', data).then((res) => {
          if (res.code == 200) {
            this.$router.push({
              path: '/'
            })
          } else {
            Notify({
              type: 'danger',
              message: '认证失败，请核对认证码后重试'
            })
          }
        })
      } else {
        Notify({
          type: 'primary',
          message: '请输入正确认证码'
        })
      }
    },
    // 认证码验证
    isLicensePlate (str) {
      return /^\d{8}$/
        .test(str)
    }
  }

}
</script>

<style>
  .login {
    box-sizing: border-box;
    padding: 0 0.32rem;
    padding-top: 1.4rem;
    background: #fff;
    min-height: 100%;
    position: fixed;
    width: 100%;
  }

  .welcome {
    position: relative;
    font-weight: bold;
  }

  .decoration {
    width: 1.24rem;
    height: 0.08rem;
    background: rgba(255, 209, 0, 0.6);
    position: absolute;
    bottom: 0.3rem;
    left: 1.3rem;
  }

  .user {
    width: 100%;
    margin-top: 1rem;
  }

  .username {
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    height: 0.8rem;
    position: relative;
  }

  .userinput {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-left: 0.2rem;
    padding-right: 0.5rem;
  }

  .viewpassword {
    width: 0.48rem;
    height: 0.48rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .loginbtn {
    width: 6.54rem;
    margin-top: 0.8rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue